import React from 'react';
import { useTheme } from 'styled-components';

interface InkGradientProps {
  readonly id: string;
  readonly width: number;
  readonly height: number;
}

const InkGradient: React.FC<InkGradientProps> = ({ id, width, height }) => {
  const { colors } = useTheme();
  return (
    <defs>
      <linearGradient id={id} gradientUnits="userSpaceOnUse" x1={0} y1={0} x2={width} y2={height}>
        <stop offset="0" stopColor={colors.primary} />
        <stop offset="1" stopColor={colors.tertiary} />
      </linearGradient>
    </defs>
  );
};

export default InkGradient;
